import React, {useState} from "react";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import MovementTypeRow from "./MovementTypeRow";
import {useDispatch, useSelector} from "react-redux";
import {
    getDataFresh,
    getMovementTypesData,
    getTrackingOptionsData,
} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import NewMovementType from "./NewMovementType";
import axios from "axios";
import {createSetDataFreshAction, createSetMovementTypesDataAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";
import {useMovementTypesData} from "../../../hooks/useMovementTypesData";


export default function MovementTypeView(props){
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    let loaded = useMovementTypesData({page}, dataFresh);
    let data = useSelector(getMovementTypesData);
    let trackingOptions = useSelector(getTrackingOptionsData);


    const onSave = (item) => {
        let url = item.id ? props.endpoint+"movementtype/"+item.id : props.endpoint+"movementtype";
        const conf = {
            url: url,
            method: item.id ? "put": "post",
            data:item
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error saving this type", {position: "top-right"});
        })
    }
    const onDelete = item => {
        const conf = {
            url: props.endpoint+"movementtype/"+item.id,
            method: "delete"
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error deleting this type", {position: "top-right"});
        })
    }
    const onChange = (e,index) => {
        let newResults = [...data.results];
        let newTypes = {...data, results: newResults}
        let newType = {...data.results[index]}
        newType[e.target.name] = e.target.value;
        newTypes.results[index] = newType
        dispatch(createSetMovementTypesDataAction(newTypes));
    }
    const onTrackingOptionChange = (e, index) =>{
        const toUpdate = {
            target: {
                name: [e.target.name],
                value: trackingOptionObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }
    if(!loaded){
        return (<LoadingSpinner />);
    }

    let trackingOptionObjects = trackingOptions.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});

    return (
        <div>
            <NewMovementType onSave={onSave} trackingOptionObjects={trackingOptionObjects} trackingOptions={trackingOptions}/>
            <Box>
                <details>
                    <summary><Title>Movement Type</Title></summary>
                    <Columns isMultiline>
                        <Column>
                            <Table isFullwidth>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Invoice Address</th>
                                        <th>Tracking Option</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((type, index) => (
                                    <MovementTypeRow
                                        type={type}
                                        handleSave={onSave}
                                        index={index}
                                        handleChange={onChange}
                                        onDelete={onDelete}
                                        trackingOptions={trackingOptions}
                                        onTrackingOptionChange={onTrackingOptionChange}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                </details>
            </Box>
        </div>
    );

}